import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NgProgress, NgProgressRef } from "@ngx-progressbar/core";
import { LoadingService } from "../../services/loading.service";

@Component({
  selector: "app-public-layout",
  templateUrl: "./public-layout.component.html",
})
export class PublicLayoutComponent implements OnInit {
  progressRef: NgProgressRef;

  constructor(
    private cdr: ChangeDetectorRef,
    private progress: NgProgress,
    private loadingService: LoadingService
  ) {
    this.loadingService.getLoading().subscribe((isLoading) => {
      if (this.progressRef) {
        if (isLoading) {
          this.progressRef.start();
          this.cdr.detectChanges();
        } else {
          this.progressRef.complete();
          this.cdr.detectChanges();
        }
      }
    });
  }

  ngOnInit() {
    this.progressRef = this.progress.ref("progressBar");
  }
}
